export interface IotMessage {
    resourceType: string
    eventType: MessageEventType
    resourceIds: string[]
    sender?: string
    updateSender?: boolean
    customInfo?: string
    targetTopics?: string[]
}

export enum MessageEventType {
    Created = "created",
    Updated = "updated",
    Deleted = "deleted",
}